<template>

  <div v-loading="loading" style="width: 1500px;margin: 60px auto 0 auto;">

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="学习情况" name="first">
        <div>
          <el-form :inline="true" :model="request" class="demo-form-inline" size="small">
            <el-form-item>
              <el-date-picker
                v-model="request.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyyMMdd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getData()">立即刷新</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div>
          <el-table :data="table.data" style="width: 100%">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column label="学习任务" prop="themeName" width="320" header-align="center">
            </el-table-column>
            <el-table-column label="学习完成率" prop="finishedPercentage" header-align="center" align="center" sortable>
              <template #default="scope">
                {{scope.row.finishedPercentageText}}
              </template>
            </el-table-column>
            <el-table-column label="课程质量评分" prop="courseStartAvgText" header-align="center" align="center" sortable>
            </el-table-column>
            <el-table-column label="老师服务评分" prop="serverStartAvgText" header-align="center" align="center" sortable>
            </el-table-column>
            <el-table-column label="学习人数" prop="count" sortable>
              <template #default="scope">
                <el-link type="primary" @click="toUserDetail(scope.row.themeName)">{{scope.row.count}}</el-link>
                人
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane label="学习情况（老师）" name="second">
        <div>
          <el-form :inline="true" :model="request" class="demo-form-inline" size="small">
            <el-form-item>
              <el-date-picker
                v-model="request.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyyMMdd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input v-model="request.teacherName" placeholder="请输入老师名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="request.themeName" placeholder="请输入学习任务" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getData()">立即刷新</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="table.dataTeacher" style="width: 100%">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column label="老师名称" prop="teacherName" header-align="center">
          </el-table-column>
          <el-table-column label="学习任务" prop="themeName" header-align="center" width="320">
          </el-table-column>
          <el-table-column label="学习完成率" prop="finishedPercentageText" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="课程质量评分" prop="courseStartAvgText" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="老师服务评分" prop="serverStartAvgText" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="学习任务" prop="name">
            <template #default="scope">
              <el-link type="primary" @click="toUserDetail(scope.row.themeName, scope.row.teacherName)">
                {{scope.row.count}}
              </el-link>
              人
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="学习情况（学生）" name="three">
        <div>
          <el-form :inline="true" :model="request" class="demo-form-inline" size="small">
            <el-form-item>
              <el-date-picker
                v-model="request.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyyMMdd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input v-model="request.userName" placeholder="请输入学生名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="request.teacherName" placeholder="请输入老师名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="request.themeName" placeholder="请输入学习任务" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getData()">立即刷新</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="table.dataUser" @sort-change="getDataSort" style="width: 100%">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column label="学生名称" prop="userName" header-align="center" width="100">
          </el-table-column>
          <el-table-column label="微信昵称" prop="weChatName" header-align="center" width="100">
          </el-table-column>
          <el-table-column label="微信号" prop="weChatNo" header-align="center" width="100">
          </el-table-column>
          <el-table-column label="老师名称" prop="teacherName" header-align="center" width="100">
          </el-table-column>
          <el-table-column label="学习任务" prop="themeName" header-align="center" width="320">
          </el-table-column>
          <el-table-column label="学习完成率" prop="finishedPercentageText" header-align="center" align="center"
                           sortable="custom" width="130">
          </el-table-column>
          <el-table-column label="课程质量评分" prop="courseStartAvgText" header-align="center" align="center"
                           sortable="custom" width="130">
          </el-table-column>
          <el-table-column label="老师服务评分" prop="serverStartAvgText" header-align="center" align="center"
                           sortable="custom" width="130">
          </el-table-column>
          <el-table-column label="账号创建时间" prop="userCreateDateText" header-align="center" sortable width="130">
          </el-table-column>
          <el-table-column label="最近学习时间" prop="latelyLearnTimeText" header-align="center" sortable width="130">
          </el-table-column>
          <el-table-column label="课程评价" prop="courseEvaluate" header-align="center">
          </el-table-column>
          <el-table-column label="操作" prop="courseEvaluate" header-align="center" width="150">
            <template #default="scope">
              <el-button type="danger" size="small" @click="openStudentInfo(scope.row)">学员信息维护</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 15px;">
          <el-pagination :page-size="request.pageSize"
                         :current-page.sync="request.pageIndex"
                         @current-change="handleCurrentChange"
                         :hide-on-single-page="true"
                         layout="prev, pager, next"
                         :total="table.total">
          </el-pagination>
        </div>

      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="学员信息维护"
      :visible.sync="studentInfoDialogVisible"
      width="600px">
      <el-form ref="form" :model="studentInfo" label-width="80px">
        <el-form-item label="学员名称">
          <el-input v-model="studentInfo.userName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="studentInfo.weChatName"></el-input>
        </el-form-item>
        <el-form-item label="微信昵称">
          <el-input v-model="studentInfo.weChatNo"></el-input>
        </el-form-item>
        <el-form-item label="老师名称">
          <el-input v-model="studentInfo.teacherName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitStudentInfo">立即修改</el-button>
          <el-button @click="closeStudentInfo">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
  import {
    doModifyUserInfo,
    doStatisticsUserLearnTask,
    doStatisticsUserLearnTaskFromTeacher,
    doStatisticsUserLearnTaskFromUser
  } from '@/utils/server';

  export default {
    name: "userlist",
    data() {
      return {
        studentInfoDialogVisible: false,
        loading: false,
        activeName: 'first',
        transferLoading: false,
        transferDialogVisible: false,
        request: {
          dateRange: null,
          userName: '',
          teacherName: '',
          themeName: '',
          clearCache: false,
          sortName: '',
          sortOrder: '',
          pageIndex: 1,
          pageSize: 15
        },
        table: {
          total: 0,
          data: [],
          dataTeacher: [],
          dataUser: []
        },
        allLeanTask: [],
        transferData: {
          value: [],
          data: [],
          sourceValue: []
        },
        userLearnTask: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit('pick', [ start, end ]);
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [ start, end ]);
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [ start, end ]);
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [ start, end ]);
              }
            } ]
        },
        studentInfo: {
          userId: '',
          userName: '',
          teacherName: '',
          weChatName: '',
          weChatNo: '',
          desc: ''
        }
      }
    },
    methods: {
      getData() {
        this.request.pageIndex = 1;
        this.request.pageSize = 15;
        this.refresh();
      },
      getDataSort({ column, prop, order }) {
        this.request.sortName = prop;
        this.request.sortOrder = order;
        this.getData();
      },
      statisticsUserLearnTask() {
        this.loading = true;
        doStatisticsUserLearnTask(this.request)
          .then(response => {
            this.table.data = response.data;
            this.request.clearCache = false;
            this.loading = false;
          })
      },
      statisticsUserLearnTaskFromTeacher() {
        this.loading = true;
        doStatisticsUserLearnTaskFromTeacher(this.request)
          .then(response => {
            this.table.dataTeacher = response.data;
            this.request.clearCache = false;
            this.loading = false;
          })
      },
      statisticsUserLearnTaskFromUser() {
        this.loading = true;
        doStatisticsUserLearnTaskFromUser(this.request)
          .then(response => {
            this.table.total = response.total;
            this.table.dataUser = response.data;
            this.request.clearCache = false;
            this.loading = false;
          })
      },
      handleCurrentChange() {
        this.refresh();
      },
      refresh() {
        if (this.activeName === 'first') {
          this.statisticsUserLearnTask();
        } else if (this.activeName === 'second') {
          this.statisticsUserLearnTaskFromTeacher();
        } else if (this.activeName === 'three') {
          this.statisticsUserLearnTaskFromUser();
        }
      },
      handleClick() {
        this.restRequest();
        this.refresh();
      },
      restRequest() {
        this.request.pageIndex = 1;
        this.request.pageSize = 15;
        this.request.userName = '';
        this.request.teacherName = '';
        this.request.themeName = '';
        this.request.sortName = '';
        this.request.sortOrder = '';
      },
      toUserDetail(themeName, teacherName) {
        this.restRequest();
        if (themeName) {
          this.request.themeName = themeName;
        }
        if (teacherName) {
          this.request.teacherName = teacherName;
        }
        this.activeName = 'three';
        this.refresh();
      },
      openStudentInfo(studentInfo) {
        this.studentInfo.targetUserId = studentInfo.userId;
        this.studentInfo.userName = studentInfo.userName;
        this.studentInfo.teacherName = studentInfo.teacherName;
        this.studentInfo.weChatName = studentInfo.weChatName;
        this.studentInfo.weChatNo = studentInfo.weChatNo;
        this.studentInfoDialogVisible = true;
      },
      onSubmitStudentInfo() {
        doModifyUserInfo(this.studentInfo)
          .then(response => {
            this.request.clearCache = true;
            this.getData();
            // this.loading = false;
            this.studentInfoDialogVisible = false;
          })
      },
      closeStudentInfo() {
        this.studentInfoDialogVisible = false;
      }
    },
    mounted() {
      this.statisticsUserLearnTask();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/statistics/index.vue